export default __webpack_public_path__ + "static/resume-7c2fec10ae6fd708380dfa6049c0d1bf.pdf";